import { render, staticRenderFns } from "./ModalAtt.vue?vue&type=template&id=13e3b020&"
import script from "./ModalAtt.vue?vue&type=script&lang=js&"
export * from "./ModalAtt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports